module.exports = __webpack_public_path__ + "img/Speaker=Michelle Reyes.81ab8cc0.png";